import {DataType} from '@wix/editor-platform-ooi-metadata-resolver'
import {SettingsParamType, createSettingsParams} from '@wix/tpa-settings'
import {SLOT_EVENT_DETAILS_CONTENT_ID, SLOT_EVENT_DETAILS_HEADER_ID} from '../../commons/constants/slots'
import type {Override} from '../../commons/types/utils'

export type ISettingsParams = {
  rsvpButtonText: SettingsParamType.Text
  rsvpEventButtonText: SettingsParamType.Text
  ticketedEventButtonText: SettingsParamType.Text
  readMoreText: SettingsParamType.Text
  readLessText: SettingsParamType.Text
  timeAndLocationTitleText: SettingsParamType.Text
  guestsTitleText: SettingsParamType.Text
  aboutTitleText: SettingsParamType.Text
  ticketsTitleText: SettingsParamType.Text
  scheduleTitleText: SettingsParamType.Text
  shareTitleText: SettingsParamType.Text
  titleTag: SettingsParamType.Text
  subtitlesTag: SettingsParamType.Text
  scheduleTitleTag: SettingsParamType.Text
  formTitleTag: SettingsParamType.Text
  formSummaryTitleTag: SettingsParamType.Text
  eventDetailsPageHeaderSlot: SettingsParamType.Object
  eventDetailsPageContentSlot: SettingsParamType.Object
}

export type PageComponentTextSettings = Override<ISettingsParams, string>

const settingsParams = createSettingsParams<ISettingsParams>({
  rsvpButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  rsvpEventButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t, getSettingParamValue}) =>
      getSettingParamValue(settingsParams.rsvpButtonText) || t('listRSVPButtonText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('listRSVPButtonText'),
      },
    }),
  },
  ticketedEventButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t, getSettingParamValue}) =>
      getSettingParamValue(settingsParams.rsvpButtonText) || t('listTicketsButtonText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('listTicketsButtonText'),
      },
    }),
  },
  readMoreText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('readMoreText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('readMoreText'),
      },
    }),
  },
  readLessText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('readLessText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('readLessText'),
      },
    }),
  },
  timeAndLocationTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('timeAndLocationTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('timeAndLocationTitleText'),
      },
    }),
  },
  guestsTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('guestsTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('guestsTitleText'),
      },
    }),
  },
  aboutTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('aboutEventTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('aboutEventTitleText'),
      },
    }),
  },
  ticketsTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('ticketsSectionTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('ticketsSectionTitleText'),
      },
    }),
  },
  shareTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('shareTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('shareTitleText'),
      },
    }),
  },
  scheduleTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('scheduleTitleText'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('scheduleTitleText'),
      },
    }),
  },
  titleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h1',
  },
  subtitlesTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h2',
  },
  scheduleTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h3',
  },
  formTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h1',
  },
  formSummaryTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h2',
  },
  eventDetailsPageHeaderSlot: {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: SLOT_EVENT_DETAILS_HEADER_ID,
          },
        },
      },
      defaultValue: {
        type: 'static',
        value: {},
      },
    },
  },
  eventDetailsPageContentSlot: {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: SLOT_EVENT_DETAILS_CONTENT_ID,
          },
        },
      },
      defaultValue: {
        type: 'static',
        value: {},
      },
    },
  },
})

export default settingsParams
